var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 9C16.1323 9 16.2594 9.05268 16.3532 9.14645C16.447 9.24021 16.4997 9.36739 16.4997 9.5V21.293L19.6457 18.146C19.7395 18.0521 19.8669 17.9994 19.9997 17.9994C20.1324 17.9994 20.2598 18.0521 20.3537 18.146C20.4475 18.2399 20.5003 18.3672 20.5003 18.5C20.5003 18.6328 20.4475 18.7601 20.3537 18.854L16.3537 22.854C16.3072 22.9006 16.252 22.9375 16.1913 22.9627C16.1305 22.9879 16.0654 23.0009 15.9997 23.0009C15.9339 23.0009 15.8688 22.9879 15.808 22.9627C15.7473 22.9375 15.6921 22.9006 15.6457 22.854L11.6457 18.854C11.5518 18.7601 11.499 18.6328 11.499 18.5C11.499 18.3672 11.5518 18.2399 11.6457 18.146C11.7395 18.0521 11.8669 17.9994 11.9997 17.9994C12.1324 17.9994 12.2598 18.0521 12.3537 18.146L15.4997 21.293V9.5C15.4997 9.36739 15.5523 9.24021 15.6461 9.14645C15.7399 9.05268 15.867 9 15.9997 9Z",
    fill: "#00948B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    transform: "matrix(1 0 0 -1 0 31)",
    stroke: "#00948B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterArrowDownIcon);
export default __webpack_public_path__ + "static/media/filter-arrow-down-icon.6ce7eec9e2af17b164327b9ff97b4378.svg";
export { ForwardRef as ReactComponent };